"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeSource = void 0;
/**
 * Possible change sources. Here are the predefined sources.
 * It can also be other string if the change source can't fall into these sources.
 */
var ChangeSource;
(function (ChangeSource) {
    /**
     * Content changed by auto link
     */
    ChangeSource["AutoLink"] = "AutoLink";
    /**
     * Content changed by create link
     */
    ChangeSource["CreateLink"] = "CreateLink";
    /**
     * Content changed by format
     */
    ChangeSource["Format"] = "Format";
    /**
     * Content changed by image resize
     */
    ChangeSource["ImageResize"] = "ImageResize";
    /**
     * Content changed by paste
     */
    ChangeSource["Paste"] = "Paste";
    /**
     * Content changed by setContent API
     */
    ChangeSource["SetContent"] = "SetContent";
    /**
     * Content changed by cut operation
     */
    ChangeSource["Cut"] = "Cut";
    /**
     * Content changed by drag & drop operation
     */
    ChangeSource["Drop"] = "Drop";
    /**
     * Insert a new entity into editor
     */
    ChangeSource["InsertEntity"] = "InsertEntity";
    /**
     * Editor is switched to dark mode, content color is changed
     */
    ChangeSource["SwitchToDarkMode"] = "SwitchToDarkMode";
    /**
     * Editor is switched to light mode, content color is changed
     */
    ChangeSource["SwitchToLightMode"] = "SwitchToLightMode";
    /**
     * List chain reorganized numbers of lists
     */
    ChangeSource["ListChain"] = "ListChain";
})(ChangeSource = exports.ChangeSource || (exports.ChangeSource = {}));
//# sourceMappingURL=ChangeSource.js.map